interface HidePrintElementProps {
  children: React.ReactNode;
}
const HidePrintElement = ({ children }: HidePrintElementProps): JSX.Element => {
  return (
    <div style={{ position: "absolute", left: "-10000000px", top: 0 }}>
      {children}
    </div>
  );
};

export default HidePrintElement;
